const Status = {
  MA: "MA",
  GI: "GI",
  PROT: "PROT",
  FP: "FP",
  LTC: "LTC",
  ER: "ER",
};

export default Status;

